import React from "react";
import Logo from "../../assets/images/Logo";
import { Alert } from "Components";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error: error.message });
  }

  render() {
    if (this.state.error !== null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "4px",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <a href="/" style={{ display: "block", width: 200 }}>
            <Logo />
          </a>
          <p>Something went wrong. Please refresh the page.</p>
          <Alert alertIsOpen={true} color="danger">
            {this.state.error}
          </Alert>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
